var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0a4 4 0 014 4v26a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4h26z",
    fill: "#0070D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.777 21.481L17 13.333l6.222 8.148",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgUpArrow;